export default function setSsmuxDebugLevel(ssmux) {
  const debugLevel = window.localStorage.getItem('SSMUX_DEBUG_LEVEL');

  if (['UNKNOWN', 'TRACE', 'VERBOSE', 'INFO', 'DEBUG', 'WARN', 'ERROR', 'FATAL', 'SILENT'].includes(debugLevel)) {
    ssmux.setDebugLevel(ssmux.LogPriority[debugLevel]);
  }

  return ssmux;
}
